<template>
    <div id="hello" style="height: 780px;">

        <div id="hello-hello">
            <b style="font-size:15px">{{ now }}</b>
        </div>

        <div style="display: flex-box;">

            <div style="display: inline;float: left;">

                <div style="display:flex;">
                    <div class="hello-sys" :style="funcStyle" @click="goBase">
                        <p style="font-size:17px;color:#6f5499;font-weight:bold;">功能系统</p>
                        <span style="color:darkgray;">租户的工作平台</span>
                    </div>

                    <div style="width:6px;"></div>

                    <div class="hello-sys" :style="devStyle" @click="goBackstage">
                        <p style="font-size:17px;color:#6f5499;font-weight:bold;">开发运营系统</p>
                        <span style="color:darkgray;">开发者、运营者使用，系统级功能，不能分配给租户。</span>
                    </div>
                </div>

                <div style="width:500px;height: 10px;"></div>

                <el-card class="box-card" :style="newsStyle">
                    <div slot="header" class="clearfix">
                        <span>今日头条</span>
                    </div>

                    <div class="text item" v-for="n in news" :key="n.newsId" @click="readNews(n.newsId)">
                        <el-link :underline="false">{{ n.title }}</el-link>
                    </div>
                </el-card>

                <el-card class="box-card" :style="personalStyle">
                    <div slot="header" class="clearfix">
                        <span>个人中心</span>
                    </div>

                    <div>
                        <p style="display:inline-block;width:80px;text-align: center;">姓名</p>
                        <el-input placeholder="请输入" v-model="newUsername" clearable
                            style="display:inline-block;width:300px"></el-input>
                    </div>

                    <div>
                        <p style="display:inline-block;width:80px;text-align: center;">智模号</p>
                        <el-input placeholder="请输入" v-model="phone" clearable disabled maxlength="11" show-word-limit
                            style="display:inline-block;width:300px"></el-input>
                    </div>

                    <div style="padding:0 0 0 300px">
                        <p></p>
                        <!-- <el-button round @click="ddd">取消</el-button> -->
                        <el-button round type="warning" @click="modifyUser">更新</el-button>
                    </div>
                </el-card>
            </div>

            <div :style="calendarStyle">
                <el-card class="box-card-right">
                    <el-calendar style="width:500px;height:630px;"></el-calendar>
                </el-card>
            </div>

            <el-header>
                <el-page-header @back="goBack" content="详情" v-show="detailHeadShow"></el-page-header>
            </el-header>

            <div id="hello-content"
                style="height:724px;overflow-y: auto;background-color: #f2f5f6;box-shadow: 0 0 6px rgba(0,0,0, .12);"
                v-show="detailShow" v-html="newsContent"></div>

            <el-backtop target="#hello-content" :bottom="100" style="color: orange;"></el-backtop>

        </div>
    </div>
</template>

<script>
export default {
    name: "Hello",
    data() {
        return {
            token: this.getToken(),
            userId: this.getUserId(),
            currentSystem: this.getCurrentSystem(),

            username: '',
            newUsername: '',
            phone: '',
            date: '',
            now: '',
            news: [],
            newsContent: '',
            newsImages: [],
            activeName: '',
            newsStyle: {
                width: '500px',
            },
            personalStyle: {
                width: '500px',
                display: 'none',
            },
            calendarStyle: {
                display: 'inline',
                float: 'right'
            },
            detailHeadShow: false,
            detailShow: false,
            funcStyle: {
                
                cursor: ''
            },
            devStyle:{
                cursor: ''
            }
        }
    },
    methods: {
        goBase() {
            
            if (this.funcStyle.cursor == 'no-drop') {
                this.$message({
                    type: 'info',
                    message: '您当前正处于[功能系统]'
                })
                return
            }

            this.setDefaultPath('/hello')
            this.$router.push({ path: "/" });

        },
        goBackstage() {

            if (this.devStyle.cursor == 'no-drop') {
                this.$message({
                    type: 'info',
                    message: '您当前正处于[开发运营系统]'
                })
                return
            }

            this.$axios({
                method: "post",
                url: "/shiro/backstage/login",
                data: {
                    id: this.userId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data
                
                if (data.status == 401) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                if(data.status==200){
                    this.setDefaultPath('/admin/hello')
                    this.$router.push({ path: "/admin/hello" })
                    
                }

            })
        },
        getUser() {
            this.$axios({
                method: "get",
                url: "/shiro/user/get?userId=" + this.userId,
                data: {}, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.username = data.data.username
                this.newUsername = data.data.username
                this.phone = data.data.phone

                this.getDate()
            })
        },
        getDate() {
            // console.log('getDate()')
            this.date = this.$moment(new Date()).format("HH")
            //console.log(this.username)
            if (5 < this.date && this.date < 8) {
                this.now = '早上好，' + this.username + '，不要忘了吃早餐，那样可没力气干活的呢'
            } else if (7 < this.date && this.date < 12) {
                this.now = '上午好，' + this.username + '，准备好开始一天的工作了吗'
            } else if (11 < this.date && this.date < 14) {
                this.now = '中午好，' + this.username + '，记得按时吃午饭哦'
            } else if (13 < this.date && this.date < 18) {
                this.now = '下午好，' + this.username + '，伸个懒腰放松一下'
            } else if (17 < this.date && this.date < 21) {
                this.now = '晚上好，' + this.username + '，忙了一天下班记得早点回家哦'
            } else if (20 < this.date && this.date < 24) {
                this.now = '夜已深了，' + this.username + '，早点休息明天又是元气满满的一天'
            } else {
                this.now = '凌晨' + this.date + '点的洛杉矶'
            }
            navigator.geolocation.getCurrentPosition((position) => {
                //alert(position)
                //console.log(position)
            })
        },
        getNews() {
            this.$axios({
                method: "get",
                url: "/shiro/news/list",
                data: {},
                headers: {
                    token: this.token
                }
            }).then(result => {
                this.news = result.data.data
            })
        },
        readNews(newsId) {
            //console.log(newsId)

            this.funcStyle.display = 'none'
            this.devStyle.display = 'none'
            this.newsStyle.display = 'none'
            this.calendarStyle.display = 'none'

            //this.newsStyle.height = '900px'
            this.detailHeadShow = true
            this.detailShow = true
            this.getContent(newsId)
        },
        goBack() {
            this.funcStyle.display = ''
            this.devStyle.display = ''
            this.calendarStyle.display = 'inline'
            this.newsStyle.display = ''

            this.detailHeadShow = false
            this.detailShow = false
        },
        getContent(newsId) {
            this.$axios({
                method: "post",
                url: "/shiro/news/get/content",
                data: {
                    newsId: newsId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.newsContent = data.data.content
                this.newsImages = data.data.images
            })
        },
        setPersonalInfo() {

            this.newsStyle.display = 'none'
            this.personalStyle.display = ''
        },
        modifyUser() {

            if (this.newUsername == '') {
                this.$message({
                    type: 'info',
                    message: '姓名不能为空'
                })
                return
            }

            this.$axios({
                method: "post",
                url: "/shiro/user/modify",
                data: {
                    id: this.userId,
                    username: this.newUsername
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.username = data.username
                location.reload()
            })
        }
    },
    created() {

        if (this.getPersonalCenter() == 1) {
            this.setPersonalInfo()
        } else {
            this.newsStyle.display = ''
            this.personalStyle.display = 'none'
        }

    },
    mounted() {

        // console.log('Hello.vue-->mounted()')
        // console.log(this.getDefaultPath())

        if(this.getDefaultPath()=='/hello'){

            this.currentSystem=0
        }else{
            this.currentSystem=1
        }
        
        this.getUser()

        this.getNews()
    },
    updated() {

        // console.log('Hello.vue-->updated()')
        // console.log(this.currentSystem)

        if (this.currentSystem == 0) {
            // this.funcStyle.pointerEvents='none'
            this.funcStyle.cursor = 'no-drop'
            this.devStyle.cursor=''
        }else{
            this.devStyle.cursor='no-drop'
            this.funcStyle.cursor = ''
        }

        if (this.newsImages != null && this.newsImages.length != 0) {
            for (let i in this.newsImages) {
                
                this.newsContent = this.newsContent.replace(this.newsImages[i].position, "<img style='max-width:1030px' src='" + this.newsImages[i].imgSrc + "'/>");
            }
        }

    }
}
</script>

<style>
#hello-hello {
    height: 50px;
    line-height: 50px;
    color: orange;
    background-color: #f2f5f6;
    border-radius: 5px;
    border: 1px solid #6f5499;
    margin: 0 0 20px 0;
}

.hello-sys {
    width: 245px;
    height: 100px;
    border: 1px solid #6f5499;
}

.hello-sys:hover {
    border: 1px solid orange;
    box-shadow: 0px 10px 10px 0px rgba(255, 165, 0, 0.5);
}

.text {
    font-size: 14px;
}

.item {
    margin-bottom: 18px;
    text-align: left;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both
}

.box-card {
    width: 480px;
}

.box-card-right {
    width: 540px;
}

#hello-content p {
    text-align: left;
    text-indent: 2em;
}

#hello-content p:nth-child(1) {
    text-align: center;
    font-size: 17px;
}
</style>